// Application constants
/**
 * Maximum number of days for history queries
 */
export const MAX_HISTORY_DAYS = 30;
/**
 * Maximum number of records returned in history queries
 */
export const MAX_HISTORY_RECORDS = 30000;
/**
 * Default page size for paginated queries
 */
export const DEFAULT_PAGE_SIZE = 50;
/**
 * Maximum page size allowed
 */
export const MAX_PAGE_SIZE = 1000;
/**
 * Maximum comments per call for QA
 */
export const MAX_COMMENTS_PER_CALL = 50;
/**
 * Large upload threshold (triggers async processing)
 */
export const LARGE_UPLOAD_THRESHOLD = 5000;
/**
 * Batch size for bulk operations
 */
export const BATCH_SIZE = 1000;
/**
 * Supported languages
 */
export const SUPPORTED_LANGUAGES = ['en', 'es', 'fr', 'de', 'pt'];
/**
 * Telephony providers
 */
export const TELEPHONY_PROVIDERS = ['telnyx', 'twilio'];
/**
 * Call directions
 */
export const CALL_DIRECTIONS = ['inbound', 'outbound'];
/**
 * QA statuses
 */
export const QA_STATUSES = {
    CRITICAL: 'Critical',
    MEDIUM_PRIORITY: 'Medium priority',
    LOW_PRIORITY: 'Low priority',
    NO_PRIORITY_ASSIGNED: 'No priority assigned',
    NEED_INFORMATION: 'Need information',
    REVIEWED: 'Reviewed',
    RESOLVED: 'Resolved',
};
/**
 * QA Categories
 * */
export const QA_CATEGORIES = {
    AUTO_QA_INCORRECT: 'Auto QA: Incorrect',
    DISPOSITION_INCORRECT: 'Disposition: Incorrect',
    LLM_AGENT_DIDNT_END_CALL: "LLM: Agent didn't end the call on time",
    LLM_INCORRECT_INFORMATION: 'LLM: Incorrect information provided',
    LLM_SCRIPT_NOT_FOLLOWED: 'LLM: Script not followed',
    LLM_SHOULD_NOT_BE_TRANSFERRED: 'LLM: Should not be transferred',
    NO_ISSUES: 'No issues',
    OTHER_TECHNICAL_ISSUE: 'Other Technical issue (e.g. failed transfer)',
    SPEECH_TO_TEXT_NOT_UNDERSTANDING: 'Speech-to-text: agent not understanding',
    TEXT_TO_SPEECH_BAD_VOICE: 'Text-to-speech: bad generated voice',
    TOO_LONG_TO_RESPOND: 'Too long to respond',
    TOO_MANY_INTERRUPTIONS: 'Too many interruptions',
};
/**
 * Change history entity types
 */
export const CHANGE_HISTORY_ENTITY_TYPES = [
    'campaign',
    'llm',
    'tool',
];
/**
 * Change history actions
 */
export const CHANGE_HISTORY_ACTIONS = [
    'create',
    'update',
    'duplicate',
    'delete',
];
export { LANGUAGES } from './languages';
export { VIEW_TYPE_LABELS, LLM_PROVIDER_ENUM_VALUES } from './llm';
